<div class="link-component">
    <!-- Hack to allow usage in grids and display data fields; this is to be removed -->
    <!-- as soon as a better solution is available. When caption is '-o-' the caption, -->
    <!-- help text and validation message is hidden. -->
    @if (caption() === '-o-') {
    <dx-text-box valueChangeEvent="keyup" [name]="caption()" [disabled]="disabled()" [readOnly]="readonly()" [isValid]="isValid" [value]="value()" (onValueChanged)="onValueChanged($event)"
        (onBlur)="onBlur()">
        <dxi-button name="picker" [options]="pickerButton" />
    </dx-text-box>
    }
    @else {
    <app-layout-control>
        <app-control-label top [control]="control()" [caption]="caption()" />
        <dx-text-box valueChangeEvent="keyup" [name]="caption()" [disabled]="disabled()" [readOnly]="readonly()" [isValid]="isValid" [value]="value()" (onValueChanged)="onValueChanged($event)"
            (onBlur)="onBlur()">
            <dxi-button name="picker" [options]="pickerButton" />
        </dx-text-box>
        <app-control-supporting-text bottom [control]="control()" [controlName]="caption()" [helpText]="helpText()" [isValid]="isValid" />
    </app-layout-control>
    }
</div>